(() => {
  if (window.__kikiCartUpsellInitialized) return;
  window.__kikiCartUpsellInitialized = true;

  const getMessage = (value) => {
    if (typeof value === 'string') return value.trim();
    if (Array.isArray(value)) return value.map(getMessage).find(Boolean) || '';
    if (value && typeof value === 'object') {
      for (const key of ['description', 'message', 'errors']) {
        const message = getMessage(value[key]);
        if (message) return message;
      }
    }
    return '';
  };

  const readResponse = async (response) => {
    const text = await response.text();
    if (!text) return { body: {}, ok: response.ok };

    try {
      return { body: JSON.parse(text), ok: response.ok };
    } catch {
      return { body: { description: text.trim() }, ok: response.ok };
    }
  };

  const setBusy = (form, busy) => {
    const button = form.querySelector('[data-cart-upsell-add]');
    const label = button?.querySelector('[data-cart-upsell-label]');
    if (!button) return;

    if (busy) {
      button.dataset.previousLabel = label?.textContent || '';
      button.setAttribute('aria-disabled', 'true');
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
      if (label) label.textContent = button.dataset.loadingLabel || label.textContent;
      return;
    }

    button.removeAttribute('aria-disabled');
    button.removeAttribute('aria-busy');
    button.disabled = false;
    if (label && button.dataset.previousLabel) {
      label.textContent = button.dataset.previousLabel;
      delete button.dataset.previousLabel;
    }
  };

  const getSections = (drawer) => {
    const sections = drawer?.getSectionsToRender?.() || [
      { id: 'cart-drawer' },
      { id: 'cart-icon-bubble' },
    ];
    return [...new Set(sections.map((section) => section?.id).filter(Boolean))];
  };

  const publishCartUpdate = (response, variantId) => {
    if (
      typeof publish !== 'function' ||
      typeof PUB_SUB_EVENTS === 'undefined' ||
      !PUB_SUB_EVENTS.cartUpdate
    ) {
      return;
    }

    try {
      Promise.resolve(
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form',
          productVariantId: variantId,
          cartData: response,
        })
      ).catch(() => {});
    } catch {
      return;
    }
  };

  const addUpsell = async (form) => {
    const card = form.closest('[data-cart-upsell]');
    const drawer = document.querySelector('cart-drawer');
    if (!card || !drawer || typeof drawer.renderContents !== 'function') return;

    const input = form.querySelector('input[name="id"]');
    const variantId = Number(input?.value || card.dataset.variantId);
    const button = form.querySelector('[data-cart-upsell-add]');
    const status = card.querySelector('[data-cart-upsell-status]');
    if (!Number.isInteger(variantId) || variantId < 1 || button?.getAttribute('aria-disabled') === 'true') {
      return;
    }

    setBusy(form, true);
    status?.toggleAttribute('hidden', true);
    if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(button);

    const controller = new AbortController();
    const timeoutId = window.setTimeout(() => controller.abort(), 8000);

    try {
      const addUrl = window.routes?.cart_add_url || '/cart/add.js';
      const payload = {
        items: [{ id: variantId, quantity: 1 }],
        sections: getSections(drawer),
        sections_url: window.location.pathname,
      };
      const response = await fetch(addUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(payload),
        signal: controller.signal,
      });
      const { body, ok } = await readResponse(response);
      const fallback = card.dataset.errorMessage || "Couldn't add this accessory. Please try again.";
      const message = getMessage(body, fallback);

      if (!ok || body?.status) {
        throw new Error(message || fallback);
      }

      if (!body?.sections || typeof body.sections['cart-drawer'] !== 'string') {
        window.location.assign(window.routes?.cart_url || '/cart');
        return;
      }

      publishCartUpdate(body, variantId);
      const rendered = drawer.renderContents(body);
      if (!rendered) {
        window.location.assign(window.routes?.cart_url || '/cart');
        return;
      }

      const liveRegion = drawer.querySelector('#CartDrawer-LiveRegionText');
      if (liveRegion) liveRegion.textContent = card.dataset.successMessage || '';
    } catch (error) {
      const fallback = card.dataset.errorMessage || "Couldn't add this accessory. Please try again.";
      const message = error?.name === 'AbortError'
        ? fallback
        : getMessage(error?.message, fallback);

      if (status) {
        status.textContent = message || fallback;
        status.removeAttribute('hidden');
      }

      if (
        typeof publish === 'function' &&
        typeof PUB_SUB_EVENTS !== 'undefined' &&
        PUB_SUB_EVENTS.cartError
      ) {
        try {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'cart-upsell',
            productVariantId: variantId,
            message: message || fallback,
          });
        } catch {
          return;
        }
      }
    } finally {
      window.clearTimeout(timeoutId);
      if (card.isConnected) setBusy(form, false);
    }
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest?.('[data-cart-upsell-form]');
    if (!form || !document.querySelector('cart-drawer')) return;
    event.preventDefault();
    addUpsell(form);
  });
})();